require('../styles/autocomplete.less');

module.exports = {
    namespace: 'autocomplete',
    listGroup: "list-group",
    notFound: 'notfound',
    found: 'found'
}


/** WEBPACK FOOTER **
 ** ./src/styles/Autocomplete-style.js
 **/